<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <!-- style="height: 50vh" -->
    <div class="flex flex-col gap-3 lg:justify-between lg:flex-row">
      <!-- Formulário -->

      <ng-container [ngSwitch]="tabSelecionada">
        <ng-container *ngSwitchCase="EPartnerTabsEdit.DadosParceiro">
          <app-tab-dados-parceiro class="w-full" [formPartner]="formPartner">
            <div
              inputImage
              class="relative rounded border border-gray-500 w-28 h-24 mb-3 cursor-pointer flex items-center justify-center h-full"
              (click)="inputLogoParceiro.click()"
            >
              <ng-container *ngIf="!partnerLogo; else temImagem">
                <span>+ LOGO</span>
              </ng-container>

              <ng-template #temImagem>
                <img
                  class="rounded-sm shadow-sm w-52 max-w-52"
                  [src]="'data:image/png;base64,' + partnerLogo"
                  alt="Logo"
                />
              </ng-template>

              <input
                type="file"
                #inputLogoParceiro
                style="display: none"
                accept="image/png"
                (change)="onImageInput($event)"
              />
            </div>
          </app-tab-dados-parceiro>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <p>Aba não encontrada.</p>
        </ng-container>
      </ng-container>

      <!-- Menu Lateral -->
      <div
        class="relative flex flex-row justify-between gap-5 p-3 lg:px-10 sm:justify-start sm:gap-3 sm:flex-wrap lg:flex-col lg:justify-end bg-iceberg menu lg:h-auto w-1/3"
        style="min-height: 550px"
      >
        <button class="absolute w-12 h-10 rounded-sm lg:top-5 right-10 btn--secondary" routerLink="/dash/parceiros">
          X
        </button>

        <div class="flex gap-y-5 flex-col mt-3">
          <div class="flex flex-col justify-end">
            <button
              type="button"
              class="btn btn--secondary"
              [ngClass]="{ 'btn--secondary--light': tabSelecionada !== EPartnerTabsEdit.DadosParceiro }"
              (click)="mudarTabSelecionada(EPartnerTabsEdit.DadosParceiro)"
            >
              Dados Parceiro
            </button>
          </div>
        </div>
        <hr class="my-4" />
        <div class="flex gap-y-5 flex-col">
          <div class="flex flex-col justify-end">
            <button
              *isAllowed="[ERoleAdminString.Admin, 'partner.update']"
              type="button"
              class="btn btn--secondary"
              (click)="editarParceiro()"
            >
              Salvar Parceiro
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
